import React from "react"
import { IconProps } from "./interfaces/IconProps.interface"

const UserPlus = (props: IconProps) => {
    return (
        <svg width="86" height="86" viewBox="0 0 86 86" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                d="M50.1654 51.0698V78.8335H14.332C14.3309 74.4578 15.3315 70.14 17.2571 66.2108C19.1827 62.2816 21.9822 58.8454 25.4411 56.1655C28.9001 53.4855 32.9266 51.6329 37.2122 50.7496C41.4977 49.8664 45.9286 49.9759 50.1654 51.0698ZM42.9987 46.5835C31.1199 46.5835 21.4987 36.9622 21.4987 25.0835C21.4987 13.2047 31.1199 3.5835 42.9987 3.5835C54.8774 3.5835 64.4987 13.2047 64.4987 25.0835C64.4987 36.9622 54.8774 46.5835 42.9987 46.5835ZM64.4987 60.9168V50.1668H71.6654V60.9168H82.4154V68.0835H71.6654V78.8335H64.4987V68.0835H53.7487V60.9168H64.4987Z"
                fill={props.color || "#000"}
            />
        </svg>
    )
}

export default UserPlus
